const SectionConnector = () => {
  return (
    <div className="section-connector"></div>
  )
}

export default SectionConnector